export default ['海洋信息', '电磁空间']